export const appRootId = "app"

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, viewport-fit=cover, user-scalable=no, maximum-scale=1.0, minimum-scale=1.0"},{"name":"theme-color","content":"#0F1622"},{"name":"mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"yes"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:site_name","property":"og:site_name","content":"ligapass"},{"hid":"og:image","property":"og:image","content":"https://pass.ligastavok.ru/static/images/share.png?v=2"},{"hid":"og:image:width","property":"og:image:width","content":"690"},{"hid":"og:image:height","property":"og:image:height","content":"300"},{"hid":"og:image:alt","property":"og:image:alt","content":"L1GAPASS"},{"hid":"og:title:default","property":"og:title","content":"Выигрывай призы от LIGAPASS"},{"hid":"og:description:default","property":"og:description","content":"Выполняй задания, находи спрятанные коды и получай крутые призы. Не упусти возможность получить фрибеты и другие крутые подарки от LIGAPASS."},{"hid":"og:image:type","name":"og:image:type","content":"website"},{"hid":"description:default","name":"description","content":"Выполняй задания, находи спрятанные коды и получай крутые призы. Не упусти возможность получить фрибеты и другие крутые подарки от LIGAPASS."},{"hid":"robots","name":"robots","content":"all"},{"hid":"yandex-verification","name":"yandex-verification","content":"edf685a601b6dca4"}],"link":[{"rel":"preconnect","href":"https://fonts.googleapis.com"},{"rel":"preconnect","href":"https://google.ru"},{"rel":"shortcut icon","type":"image/x-icon","sizes":"32x32","href":"/favicon.ico"},{"rel":"icon","type":"image/svg+xml","href":"/favicon.svg"},{"rel":"icon","sizes":"32x32","href":"/favicon.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/favicon-apple-touch.png"},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Montserrat:wght@400;500;600;700;900&display=swap"}],"style":[],"script":[{"hid":"ym-loader","type":"text/javascript","children":"(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};m[i].l=1*new Date();for(var j=0;j<document.scripts.length;j++){if(document.scripts[j].src===r){return;}}k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})(window,document,'script','https://mc.yandex.ru/metrika/tag.js?id=104044567','ym');ym(104044567,'init',{ssr:true,webvisor:true,clickmap:true,ecommerce:'dataLayer',accurateTrackBounce:true,trackLinks:true});"},{"hid":"chat-widget","type":"text/javascript","src":"https://cc.chat.ligastavok.ru/fv2/chat.js","async":true}],"noscript":[],"titleTemplate":"%s | Liga Pass","title":"Выигрывай призы от LIGAPASS"}

export const appBuildAssetsDir = "static"

export const appCdnURL = "/"

export const appBaseURL = "/"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootTag = "div"

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = false

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#app'

export const viewTransition = false